import { buildCategoryRoute, buildDiscoverRoute } from '~/routes';

export const createCategoryLink = (category) => {
  if (!category || !category?.slug) return null;

  return category.parent
    ? buildCategoryRoute(category?.parent.slug, category?.slug)
    : buildDiscoverRoute(category?.slug);
};
